import { ArrowLeftOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Card, Col, Input, Row, Typography, message } from "antd";
import axios from "axios";
import { PRIMARY_RED } from "constants/colors";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { setBreadcrumbItems } from "../../store/actions";

const { Text } = Typography;

const EditDesignation = ({ setBreadcrumbItems }) => {
  const [designation, setDesignation] = useState("");
  const navigate = useNavigate();
  const { id } = useParams();

  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const token = authUser?.token;

  const breadcrumbItems = [
    { title: "Designation", link: "#" },
    { title: "Edit Designation", link: "#" },
  ];

  useEffect(() => {
    setBreadcrumbItems("Edit Designation", breadcrumbItems);
  }, [setBreadcrumbItems]);

  useEffect(() => {
    const fetchDesignation = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASEURL}/designation/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setDesignation(response.data?.designation || "");
      } catch (error) {
        console.error(error);
        message.error("Failed to fetch designation");
      }
    };

    if (id) fetchDesignation();
  }, [id, token]);

  const handleUpdate = async () => {
    if (!designation.trim()) {
      message.warning("Please enter a designation");
      return;
    }

    try {
      await axios.put(
        `${process.env.REACT_APP_API_BASEURL}/designation/${id}/`,
        { designation },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            accept: "*/*",
          },
        }
      );
      message.success("Designation updated successfully");
      navigate("/designations");
    } catch (error) {
      console.error(error);
      message.error("Failed to update designation");
    }
  };

  return (
    <div className="p-4">
      <Card style={{ marginTop: 20 }} title="Edit Designation">
        <Row>
          <Col span={24}>
            <Text strong>Designation</Text>
            <Input
              placeholder="Sales Manager"
              value={designation}
              onChange={(e) => setDesignation(e.target.value)}
              style={{ marginBottom: 20 }}
            />
          </Col>
        </Row>

        <Row gutter={16}>
          <Col>
            <Button
              type="primary"
              icon={<EditOutlined />}
              style={{ backgroundColor: PRIMARY_RED }}
              onClick={handleUpdate}
            >
              Edit Designation
            </Button>
          </Col>
          <Col>
            <Button
              type="link"
              style={{ color: PRIMARY_RED }}
              icon={<ArrowLeftOutlined />}
              onClick={() => navigate("/designations")}
            >
              Back
            </Button>
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default connect(null, { setBreadcrumbItems })(EditDesignation);
